var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "MaterialInput",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { integer: true, min_value: 0 },
                  expression: "{integer: true, min_value:0}",
                },
              ],
              staticClass: "city-form-group city-bg",
              attrs: {
                readonly: _vm.readonlyForm,
                disabled: _vm.readonlyForm,
                id: "input-interment_number",
                name: "interment_number",
                "data-vv-scope": _vm.vScope,
                inputClasses: [
                  {
                    "is-invalid": _vm.fnHasError(
                      "interment_number",
                      _vm.vScope
                    ),
                  },
                ],
                error: _vm.fnFirstError("interment_number", _vm.vScope),
              },
              model: {
                value: _vm.form.interment.number,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.form.interment,
                    "number",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "form.interment.number",
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t(`${_vm.modelTranslateID}.interment_number`)) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "MaterialDateRangePicker",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "",
                  expression: "''",
                },
              ],
              staticClass: "city-form-group city-bg",
              attrs: {
                id: "input-entity_death_at",
                name: "entity_death_at",
                dateFormat: _vm.labelDateFormat,
                databaseDateFormat: _vm.dateFormat,
                "data-vv-scope": _vm.vScope,
                inputClasses: [
                  { "is-invalid": _vm.fnHasError("interment_at", _vm.vScope) },
                ],
                error: _vm.fnFirstError("interment_at", _vm.vScope),
              },
              model: {
                value: _vm.form.interment.interment_at,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.form.interment,
                    "interment_at",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "form.interment.interment_at",
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t(`${_vm.modelTranslateID}.interment_at`)) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _c("label", [
        _vm._v(_vm._s(_vm.$t(`${_vm.entityTranslateID}.form.deceased_entity`))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "",
                      expression: "''",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    readonly: _vm.readonlyForm,
                    disabled: _vm.readonlyForm,
                    id: "input-entity_name",
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError("entity_name", _vm.vScope),
                      },
                    ],
                    error: _vm.fnFirstError("entity_name", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.interment.entity.name,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form.interment.entity,
                        "name",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.interment.entity.name",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelEntityTranslateID}.name`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialDateRangePicker",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "",
                      expression: "''",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    id: "input-entity_birth_at",
                    name: "entity_birth_at",
                    dateFormat: _vm.labelDateFormat,
                    databaseDateFormat: _vm.dateFormat,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "entity_birth_at",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("entity_birth_at", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.interment.entity.birth_at,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form.interment.entity,
                        "birth_at",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.interment.entity.birth_at",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelEntityTranslateID}.birth_at`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialDateRangePicker",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "",
                      expression: "''",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    id: "input-entity_death_at",
                    name: "entity_death_at",
                    dateFormat: _vm.labelDateFormat,
                    databaseDateFormat: _vm.dateFormat,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "entity_death_at",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("entity_death_at", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.interment.entity.death_at,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form.interment.entity,
                        "death_at",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.interment.entity.death_at",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelEntityTranslateID}.death_at`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-auto d-flex align-items-center" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t(`${_vm.entityTranslateID}.form.age`))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { integer: true, min_value: 0 },
                          expression: "{integer: true, min_value:0}",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyForm,
                        disabled: _vm.readonlyForm,
                        type: "number",
                        id: "input-fromAge",
                        name: "fromAge",
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError("fromAge", _vm.vScope),
                          },
                        ],
                        error: _vm.fnFirstError("fromAge", _vm.vScope),
                      },
                      model: {
                        value: _vm.form.interment.entity.age.from,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.interment.entity.age,
                            "from",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.interment.entity.age.from",
                      },
                    },
                    [
                      _vm._v(
                        "\n                                " +
                          _vm._s(
                            _vm.$t(`${_vm.modelEntityTranslateID}.from_age`)
                          ) +
                          "\n                            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            integer: true,
                            min_value: _vm.form.interment.entity.age.from ?? 0,
                          },
                          expression:
                            "{integer: true, min_value: form.interment.entity.age.from ?? 0 }",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyForm,
                        disabled: _vm.readonlyForm,
                        type: "number",
                        id: "input-toAge",
                        name: "toAge",
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("toAge", _vm.vScope) },
                        ],
                        error: _vm.fnFirstError("toAge", _vm.vScope),
                      },
                      model: {
                        value: _vm.form.interment.entity.age.to,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.interment.entity.age,
                            "to",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.interment.entity.age.to",
                      },
                    },
                    [
                      _vm._v(
                        "\n                                " +
                          _vm._s(
                            _vm.$t(`${_vm.modelEntityTranslateID}.to_age`)
                          ) +
                          "\n                            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-auto d-flex align-items-center" }, [
      _c("div", { staticClass: "form-group" }, [_c("span", [_vm._v("-")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }